import { Component, OnInit, Inject, EventEmitter, Output } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef, MatDialog } from "@angular/material";
import { SchedulingService } from "../../scheduling.service";
import { Scheduling, Schedule } from "../../scheduling.model";
import { SchedulingUtils } from "../../shedulling.utils";
import { ScheduleType, ClientTariff } from "../../../../shared/constants";
import { cloneDeep } from "lodash";
import { Constants } from "../../../../core/services/constants";
import { GeneralService } from "../../../../shared/services/general.service";
import { SCHEDULE_TYPE, MODE } from "../../scheduling.constants";
import { SessionStateService } from "../../../../core/services/session-state.service";
import { Device } from "../../../devices/devices.model_new";
import { HVACModel } from "../../../devices/devices.utils";
import { DevicesService } from "../../../devices/devices.service";
import { ClimatizationDeviceType } from "../../../devices/devices.constant";
import { DeleteConfirmDialogComponent } from "../../../../shared/components/delete-confirm-dialog/delete-confirm-dialog.component";

@Component({
  selector: "app-scheduling-schedules-dialog",
  templateUrl: "./scheduling-schedules-dialog.component.html",
  styleUrls: ["./scheduling-schedules-dialog.component.scss"],
})
export class SchedulingSchedulesDialogComponent implements OnInit {
  loading = false;
  device: Device;
  scheduling: Scheduling;
  economic: boolean;
  SchedulingUtils = SchedulingUtils;

  hvacModel: HVACModel;
  termostatModel: boolean;

  createMode = false;
  schedule: Schedule;
  types: SCHEDULE_TYPE[] = [];
  errorMessage: string;
  schedulingConflictError: boolean;
  dialogDelRef: MatDialogRef<DeleteConfirmDialogComponent>;

  @Output() updateScheduling: EventEmitter<Schedule> = new EventEmitter();

  constructor(
    private schedulingService: SchedulingService,
    private sessionStateService: SessionStateService,
    public dialogRef: MatDialogRef<SchedulingSchedulesDialogComponent>,
    private generalService: GeneralService,
    private dialog: MatDialog,
    private devicesService: DevicesService,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.device = data.device;
    this.scheduling = data.scheduling;
    this.types = data.type;
    if (
      (this.scheduling.getSchedules().length === 0 &&
        this.types.includes(SCHEDULE_TYPE.ON_OFF)) ||
      (this.scheduling.getSchedules().length === 0 &&
        this.types.includes(SCHEDULE_TYPE.STAND_BY_KILLER)) ||
      (this.scheduling.getSchedules().length === 0 &&
        this.types.includes(SCHEDULE_TYPE.THERMOSTAT)) ||
      (this.scheduling.getSchedules().length === 0 &&
        this.types.includes(SCHEDULE_TYPE.HVAC)) ||
      this.types.includes(SCHEDULE_TYPE.ECONOMIC)
    ) {
      this.createMode = true;
      if (
        this.scheduling.getSchedules().length === 1 &&
        this.types.includes(SCHEDULE_TYPE.ECONOMIC)
      ) {
        this.schedule = cloneDeep(this.scheduling.getSchedules()[0]);
      }
    }
    if (this.device.getSubType() === ClimatizationDeviceType.AIR_CONDITIONING) {
      this.devicesService
        .getHavcBrandsandModel(
          this.device.getUserAttribute("brand"),
          this.device.getUserAttribute("model")
        )
        .subscribe((hvacResponse) => {
          this.hvacModel = hvacResponse;
          this.types = [SCHEDULE_TYPE.HVAC];
        });
    } else if (
      this.device.getSubType() === ClimatizationDeviceType.THERMOSTAT
    ) {
      this.termostatModel = true;
      this.types = [SCHEDULE_TYPE.THERMOSTAT];
    } else {
      this.termostatModel = false;
    }
  }

  ngOnInit() {}

  onUpdateScheduling(schedule?: Schedule) {
    this.createMode = true;
    this.schedule = cloneDeep(schedule);
  }

  onDeleteScheduling(schedule: Schedule) {
    this.dialogDelRef = this.dialog.open(DeleteConfirmDialogComponent, {
      data: {
        element: "SCHEDULE",
        message: `Schedule ${schedule.getType()} with horary: ${schedule.getHorary()}
        ${this.generalService.translate.instant(
          "will be permanently deleted."
        )}`,
        small: true,
      },
      autoFocus: false,
      panelClass: "deleteGenericPopup",
    });

    const sub = this.dialogDelRef.componentInstance.action.subscribe(
      (toDelete: boolean) => {
        if (toDelete) {
          schedule.toDelete = true;
          this.schedulingService
            .deleteSchedule(
              this.sessionStateService.getHouse().houseId,
              schedule
            )
            .subscribe((res) => {
              this.onScheduleEmit(schedule);
            });
        }
      }
    );
  }

  canCreateSchedule(): boolean {
    return (
      this.types.includes(SCHEDULE_TYPE.ON_OFF) ||
      this.types.includes(SCHEDULE_TYPE.STAND_BY_KILLER) ||
      this.types.includes(SCHEDULE_TYPE.HVAC) ||
      this.types.includes(SCHEDULE_TYPE.THERMOSTAT) ||
      (this.types.includes(SCHEDULE_TYPE.ECONOMIC) &&
        this.scheduling.getSchedules().length < 1)
    );
  }

  onScheduleEmit(s: Schedule) {
    this.loading = true;
    if (!s.getId()) {
      s.setModuleId(this.device.getModuleId());
      this.schedulingService
        .createSchedule(this.sessionStateService.getHouse().houseId, s)
        .finally(() => (this.loading = false))
        .subscribe((res) => {
          if (res["ruleId"] != null) {
            s.setId(res["ruleId"]);
            this.scheduling.addSchedule(s);
            this.updateScheduling.emit(s);
            this.createMode = false;
            if (this.types.includes(SCHEDULE_TYPE.ECONOMIC)) {
              this.dialogRef.close();
            }
          } else {
            this.errorMessage = res.message;
          }
        });
    } else if (s.getId() && s.toDelete) {
      this.schedulingService
        .deleteSchedule(this.sessionStateService.getHouse().houseId, s)
        .finally(() => (this.loading = false))
        .subscribe((res) => {
          this.scheduling.removeSchedule(s);
          this.updateScheduling.emit(s);
          this.createMode = false;
          if (this.types.includes(SCHEDULE_TYPE.ECONOMIC)) {
            this.dialogRef.close();
          }
        });
    } else if (s.getId() && !s.toDelete) {
      this.schedulingService
        .updateSchedule(this.sessionStateService.getHouse().houseId, s)
        .finally(() => (this.loading = false))
        .subscribe((res) => {
          this.scheduling.updateSchedule(s);
          this.updateScheduling.emit(s);
          this.createMode = false;
          if (this.types.includes(SCHEDULE_TYPE.ECONOMIC)) {
            this.dialogRef.close();
          }
        });
    }
  }

  onCloseDialog() {
    this.dialogRef.close();
  }

  getOperationModeIcon(schedule) {
    if (schedule.getType() === SCHEDULE_TYPE.HVAC) {
      switch (schedule.getMode()) {
        case MODE.OFF: {
          return "./assets/img/icons/ic-ac-mode-fan-off-dark.svg";
        }
        case MODE.AUTO: {
          return "./assets/img/icons/ic-ac-mode-fan-auto-dark.svg";
        }
        case MODE.HEAT: {
          return "./assets/img/icons/ic-ac-mode-heat-dark.svg";
        }
        case MODE.COOL: {
          return "./assets/img/icons/ic-ac-mode-cold-dark.svg";
        }
        case MODE.DRY: {
          return "./assets/img/icons/ic-ac-mode-fan-dry-dark.svg";
        }
        case MODE.FAN: {
          return "./assets/img/icons/ic-ac-mode-fan-dark.svg";
        }
        default: {
          return "";
        }
      }
    } else if (schedule.getType() === SCHEDULE_TYPE.THERMOSTAT) {
      return "./assets/img/icons/ic-ac-mode-heat-dark.svg";
    }
  }

  getScheduleIcon(schedule): string {
    switch (schedule.getType()) {
      case SCHEDULE_TYPE.HVAC: {
        return schedule.getState()
          ? "../../../../../../assets/img/icons/ic-schedule-setpoint.svg"
          : "../../../../../../assets/img/icons/ic-schedule-setpoint-disabled.svg";
      }
      case SCHEDULE_TYPE.THERMOSTAT: {
        return schedule.getState()
          ? "../../../../../../assets/img/icons/ic-schedule-setpoint.svg"
          : "../../../../../../assets/img/icons/ic-schedule-setpoint-disabled.svg";
      }
      case SCHEDULE_TYPE.STAND_BY_KILLER: {
        return schedule.getState()
          ? "../../../../../../assets/img/icons/ic-schedule-standbykiller.svg"
          : "../../../../../../assets/img/icons/ic-schedule-standbykiller-disabled.svg";
      }
      case SCHEDULE_TYPE.ECONOMIC: {
        return schedule.getState()
          ? "../../../../../../assets/img/icons/ic-schedule-economic.svg"
          : "../../../../../../assets/img/icons/ic-schedule-economic-disabled.svg";
      }
      case SCHEDULE_TYPE.ON_OFF: {
        return schedule.getState()
          ? "../../../../../../assets/img/icons/ic-schedule-onoff.svg"
          : "../../../../../../assets/img/icons/ic-schedule-onoff-disabled.svg";
      }
    }
  }

  getScheduleState(schedule) {
    if (schedule) {
      return schedule.getState();
    } else {
      return false;
    }
  }

  changeState(schedule: Schedule) {
    const newState = !schedule.getState();
    this.schedulingService
      .updateState(
        this.sessionStateService.getHouse().houseId,
        schedule,
        newState
      )
      .subscribe((res) => {
        schedule.setState(!schedule.getState());
        this.scheduling.updateSchedule(schedule);
      });
  }

  isTypeOnOff() {
    return this.types.includes(SCHEDULE_TYPE.ON_OFF);
  }
}



// WEBPACK FOOTER //
// ./src/app/entities/scheduling/scheduling-tab/scheduling-schedules-dialog/scheduling-schedules-dialog.component.ts